export { default } from "./DeltaLabel";
